import { vuex as app } from "@/domains";
// cria um novo objeto e preserva as chaves originais
export default { ...app.modules };
